import { render, staticRenderFns } from "./create-message-dialog.vue?vue&type=template&id=7c518c5c&"
import script from "./create-message-dialog.vue?vue&type=script&lang=js&"
export * from "./create-message-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports